import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { categories } from '@/mocks/site';

export default function CategorySection() {
  return (
    <section id="category" className="w-full scroll-mt-24 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="Genres"
          title="按主题找想追的剧"
          desc="短剧题材多、更新快，先按主题缩小范围，再进剧集库按分类筛选。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category, index) => (
            <Link
              key={category.key}
              to={`/dramas?category=${encodeURIComponent(category.key)}`}
              className={`group cursor-pointer rounded-lg border p-5 transition-colors duration-200 md:p-6 ${
                index === 1
                  ? 'border-accent-300 bg-accent-50 hover:border-accent-500'
                  : 'border-background-200 bg-background-50 hover:border-primary-300'
              }`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-md ${
                    index === 1 ? 'bg-accent-500 text-secondary-950' : 'bg-primary-50 text-primary-600'
                  }`}
                >
                  <i className={`${category.icon} text-xl`} aria-hidden="true" />
                </span>
                <span className="font-display text-3xl text-background-300 transition-colors group-hover:text-primary-200">
                  0{index + 1}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{category.key}</h3>
              <p className="mt-1 text-sm text-foreground-600">{category.desc}</p>
              <p className="mt-4 flex items-center gap-1 text-xs text-foreground-500">
                {category.count} 部在追
                <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}